import type { CreateInventorizationDraftInput } from '@/features/today/useCreateInventorizationDraft';
import {
  METER_IDENTIFIER_KINDS,
  type MeterSearchResult,
  type NormalizedMeterIdentifier,
} from '@/shared/meter-identification';

export function createDraftInputFromIdentifier(
  identifier: NormalizedMeterIdentifier,
  preferApiKey: boolean,
): CreateInventorizationDraftInput {
  if (preferApiKey || identifier.kind === METER_IDENTIFIER_KINDS.apiKey) {
    return {
      identity: {
        apiKey: identifier.rawValue.trim(),
      },
    };
  }

  if (identifier.kind === METER_IDENTIFIER_KINDS.serial) {
    return {
      identity: {
        serial: identifier.normalizedValue,
      },
    };
  }

  return {};
}

export function createDraftInputFromUnmatchedIdentifier(
  identifier: NormalizedMeterIdentifier,
): CreateInventorizationDraftInput {
  return createDraftInputFromIdentifier(identifier, true);
}

export function createDraftInputFromMeter(
  identifier: NormalizedMeterIdentifier,
  meter: MeterSearchResult,
  preferApiKey: boolean,
): CreateInventorizationDraftInput {
  return {
    ...createDraftInputFromIdentifier(identifier, preferApiKey || meter.matchedBy === METER_IDENTIFIER_KINDS.apiKey),
    matchedMeter: meter,
  };
}

export function createPassportWizardDraftInputFromMeter(
  identifier: NormalizedMeterIdentifier,
  meter: MeterSearchResult,
  preferApiKey: boolean,
): CreateInventorizationDraftInput {
  return {
    ...createDraftInputFromMeter(identifier, meter, preferApiKey),
    startWizard: true,
  };
}
